import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment';
import { cmp, getShift } from '../helpers/misc';
import { v4 as uuid } from 'uuid'


const mapStateToProps = state => ({
  colorScheme: state.main.colorScheme,
  machineData: state.app.machineData,
  locatorFilter: state.app.locatorFilter,
  locationData: state.app.locationData,
});

const MoldChangeModal = props => {
  const {
    colorScheme,
    machineData,
    locatorFilter,
    locationData,
    show,
    onHide,
  } = props;
  const [curShiftChanges, setCurShiftChanges] = useState([]);
  const [nextShiftChanges, setNextShiftChanges] = useState([]);
  const [nextNextShiftChanges, setNextNextShiftChanges] = useState([]);
  const [nextNextNextShiftChanges, setNextNextNextShiftChanges] = useState([]);
  const [curShiftTitle, setCurShiftTitle] = useState('THIS SHIFT');
  const [nextShiftTitle, setNextShiftTitle] = useState('NEXT SHIFT');
  const [nextNextShiftTitle, setNextNextShiftTitle] = useState('NEXT NEXT SHIFT');
  const [nextNextNextShiftTitle, setNextNextNextShiftTitle] = useState('NEXT NEXT NEXT SHIFT');
  
  useEffect(() => {
    if(!show) return;
    const locationObj = locationData ? locationData.get(locatorFilter) : null;
    const filteredMachineData = machineData ?
      machineData.filter(machineObj => locatorFilter === 'ALL' || machineObj.machineLocator === locatorFilter) :
      null;
    const changes = filteredMachineData.map(machineObj => machineObj.schedule.filter(o => !o.isStoppage)
      .map((scheduleObj, index) => {
        let currentJob;
        if(index === 0) {
          const curJobs = machineObj.jobs.find(jobArr => jobArr.some(job => job.actualEndDate === 0));
          const curJobId = curJobs ? curJobs.map(j => j.jobNumber).join('|') : null;
          if(curJobId) {
            if(curJobId !== scheduleObj.schedulingId) currentJob = {
              scheduleObj: {
                dynamicStartTime: scheduleObj.startTime,
                endTime: scheduleObj.startTime,
                jobNumbers: curJobs.map(j => j.jobNumber),
                machineCommonName: scheduleObj.machineCommonName,
                machineLocator: scheduleObj.machineLocator,
                machineSerialNumber: scheduleObj.machineSerialNumber,
                schedulingId: curJobId,
                startTime: scheduleObj.startTime,
              },
              jobArr: curJobs,
            };
          }
          else currentJob = {
            scheduleObj: {
              dynamicStartTime: scheduleObj.startTime,
              endTime: scheduleObj.startTime,
              jobNumbers: ['NONE'],
              machineCommonName: scheduleObj.machineCommonName,
              machineLocator: scheduleObj.machineLocator,
              machineSerialNumber: scheduleObj.machineSerialNumber,
              schedulingId: uuid(),
              startTime: scheduleObj.startTime,
            },
            jobArr: 'NONE',
          }
        }
        const jobArr = machineObj.jobs.find(arr => arr.some(obj => scheduleObj.jobNumbers.includes(obj.jobNumber)));
        if(!jobArr) return [currentJob, null];
        return [
          currentJob,
          {
            scheduleObj,
            jobArr,
          },
        ];
      })
      .flat()
      .filter(o => o != null)
      .map(({ scheduleObj, jobArr }, index, arr) => {
        if(index === arr.length - 1) return null;
        const nextJobRecords = arr[index + 1]?.jobArr;
        const nextTooNumber = nextJobRecords && nextJobRecords.length ? nextJobRecords[0].toolNumber : null;
        const nextJobNumber = nextJobRecords && nextJobRecords.length ? nextJobRecords.map(job => job.jobNumber).join(' & ') : null;
        const nextPartNumber = nextJobRecords && nextJobRecords.length ? nextJobRecords.map(job => job.partNumber).join(' & ') : null;
        const shiftData = getShift(arr[index + 1].scheduleObj.startTime, machineObj.standards.timeZone, machineObj.standards.shiftTimes);
  
        let previousToolNumber, previousJobNumber, previousPartNumber;
        if(jobArr === 'NONE') {
          previousToolNumber = 'NONE';
          previousJobNumber = 'NONE';
          previousPartNumber = 'NONE';
        }
        else {
          previousToolNumber = jobArr && jobArr.length ? jobArr[0].toolNumber : null;
          previousJobNumber = jobArr && jobArr.length ? jobArr.map(job => job.jobNumber).join(' & ') : null;
          previousPartNumber = jobArr && jobArr.length ? jobArr.map(job => job.partNumber).join(' & ') : null;
        }
        
        if(!previousToolNumber || !nextTooNumber || !previousJobNumber || !nextJobNumber ||
          !previousPartNumber || !nextPartNumber || previousToolNumber === nextTooNumber) return null;
        return {
          changeTime: arr[index + 1].scheduleObj.startTime,
          machine: machineObj.serialNumber,
          machineCommonName: machineObj.commonName,
          previousToolNumber,
          nextTooNumber,
          previousJobNumber,
          nextJobNumber,
          previousPartNumber,
          nextPartNumber,
          ...shiftData,
        };
      })).flat().filter(obj => obj != null).sort((a, b) => cmp(a.changeTime, b.changeTime));
    const now = Date.now();
    const currentShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes) : null;
    const nextShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes, 1) : null;
    const nextNextShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes, 2) : null;
    const nextNextNextShiftData = locationObj ? getShift(now, locationObj.timeZone, locationObj.shiftTimes, 3) : null;
    const thisShiftChanges = changes.filter(obj => obj.changeTime <= now ||
      (obj.shiftName === currentShiftData.shiftName && obj.shiftDate === currentShiftData.shiftDate));
    const nextShiftChanges = changes.filter(obj => obj.shiftName === nextShiftData.shiftName &&
      obj.shiftDate === nextShiftData.shiftDate);
    const nextNextShiftChanges = changes.filter(obj => obj.shiftName === nextNextShiftData.shiftName &&
      obj.shiftDate === nextNextShiftData.shiftDate);
    const nextNextNextShiftChanges = changes.filter(obj => obj.shiftName === nextNextNextShiftData.shiftName &&
      obj.shiftDate === nextNextNextShiftData.shiftDate);
    setCurShiftChanges(thisShiftChanges);
    setNextShiftChanges(nextShiftChanges);
    setNextNextShiftChanges(nextNextShiftChanges);
    setNextNextNextShiftChanges(nextNextNextShiftChanges);
    setCurShiftTitle(`${currentShiftData.shiftDate} | SHIFT ${currentShiftData.shiftName}`);
    setNextShiftTitle(`${nextShiftData.shiftDate} | SHIFT ${nextShiftData.shiftName}`);
    setNextNextShiftTitle(`${nextNextShiftData.shiftDate} | SHIFT ${nextNextShiftData.shiftName}`);
    setNextNextNextShiftTitle(`${nextNextNextShiftData.shiftDate} | SHIFT ${nextNextNextShiftData.shiftName}`);
  }, [locationData, machineData, locatorFilter, show]);
  
  
  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={() => onHide()}
      className={`modal-content-${colorScheme.toUpperCase()}`}
    >
      <Modal.Header>
        <Modal.Title>
          MOLD CHANGES
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles.modalBody}>
        <h5 style={styles.title}>{`${curShiftTitle} -> ${curShiftChanges.length}`}</h5>
        {curShiftChanges.map((obj, index) =>
          <p key={index} style={styles.text}>
            {`${moment(obj.changeTime).format('MM/DD h:mmA')} -> ${obj.machineCommonName} | ${obj.previousToolNumber} -> ${obj.nextTooNumber} | ${obj.previousJobNumber} -> ${obj.nextJobNumber} | ${obj.previousPartNumber} -> ${obj.nextPartNumber}`}
          </p>,
        )}
        
        <h5 style={styles.title}>{`${nextShiftTitle} -> ${nextShiftChanges.length}`}</h5>
        {nextShiftChanges.map((obj, index) =>
          <p key={index} style={styles.text}>
            {`${moment(obj.changeTime).format('MM/DD h:mmA')} -> ${obj.machineCommonName} | ${obj.previousToolNumber} -> ${obj.nextTooNumber} | ${obj.previousJobNumber} -> ${obj.nextJobNumber} | ${obj.previousPartNumber} -> ${obj.nextPartNumber}`}
          </p>,
        )}
        
        <h5 style={styles.title}>{`${nextNextShiftTitle} -> ${nextNextShiftChanges.length}`}</h5>
        {nextNextShiftChanges.map((obj, index) =>
          <p key={index} style={styles.text}>
            {`${moment(obj.changeTime).format('MM/DD h:mmA')} -> ${obj.machineCommonName} | ${obj.previousToolNumber} -> ${obj.nextTooNumber} | ${obj.previousJobNumber} -> ${obj.nextJobNumber} | ${obj.previousPartNumber} -> ${obj.nextPartNumber}`}
          </p>,
        )}
        
        <h5 style={styles.title}>{`${nextNextNextShiftTitle} -> ${nextNextNextShiftChanges.length}`}</h5>
        {nextNextNextShiftChanges.map((obj, index) =>
          <p key={index} style={styles.text}>
            {`${moment(obj.changeTime).format('MM/DD h:mmA')} -> ${obj.machineCommonName} | ${obj.previousToolNumber} -> ${obj.nextTooNumber} | ${obj.previousJobNumber} -> ${obj.nextJobNumber} | ${obj.previousPartNumber} -> ${obj.nextPartNumber}`}
          </p>,
        )}
      
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => onHide()}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const styles = {
  title: {
    marginTop: 20,
    marginBottom: 5,
  },
  text: {
    margin: 0,
  },
  modalBody: {
    paddingTop: 0,
  },
};

export default connect(mapStateToProps)(MoldChangeModal);